module.exports = __webpack_public_path__ + "img/tso.8a27feb1.png";